import { Modal, Form, Input } from "antd-mobile";
import { useCallback, useState } from "react";
import { useIntl } from "react-intl";
import styled from "styled-components";

export default function useTansferModal() {
  const intl = useIntl()
  const show = ({ onConfrim = () => {} }) => {
    let code = "";
    return Modal.show({
      title: intl.formatMessage({id:'components.tranfer_modal.title',defaultMessage:"轉讓"}),
      bodyClassName: "runbit_modal",
      showCloseButton:true,
      actions: [
        {
          key: "prev",
          className: "border_btn",
          text: intl.formatMessage({id:'common.cancel',defaultMessage:"取消"}),
        },
        {
          key: "comfrim",
          className: "primary_btn",
          text: intl.formatMessage({id:'components.tranfer_modal.title',defaultMessage:"轉讓"}),
          primary: true,
        },
      ],
      onAction: (action, index) => {
        if(action.key === 'comfrim') {
          onConfrim(code);
        }
      },
      closeOnAction: false,
      content: (
        <>
          <Tip>{
            intl.formatMessage({id:'components.tranfer_modal.tip',defaultMessage:"請校驗正確的轉讓地址，以防卡片遺失"})
            }</Tip>
          <Form layout="horizontal" className="runbit_form">
            <Form.Item className="runbit_form_item" label={intl.formatMessage({id:'components.tranfer_modal.address',defaultMessage:"地址"})} name="code">
              <Input
                placeholder={intl.formatMessage({id:'components.tranfer_modal.enter_address',defaultMessage:"输入地址"})}
                clearable
                onChange={(e) => {
                  code = e;
                }}
              />
            </Form.Item>
          </Form>
        </>
      ),
    });
  };
  return {
    show
  };
}

const Tip = styled.p`
  font-style: normal;
  font-weight: 400;
  font-size: 1.6rem;
  line-height: 1.6rem;
  /* identical to box height, or 100% */

  text-align: center;
  text-transform: capitalize;

  color: #000000;
  margin-bottom: 2.0rem;
`;
